class FormsService extends CrudManager {
    path = '/realestate/forms';
}

angular
    .module('app')
    .service('formsService', [...FormsService.$inject, FormsService]);
